module.exports = __webpack_public_path__ + "img/single-product-43.878d5a9.webp";